import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../../service/user.abstract.service';
import { ProfileResponse } from '../../user.model';

@Component({
    selector: 'app-user-confirm-account-dialog',
    templateUrl: './user-confirm-account.component.html',
    styleUrls: ['./user-confirm-account.component.scss'],
})
export class UserConfirmAccountDialogComponent implements OnInit {
    public profile: ProfileResponse;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { id: string },
        public dialogRef: MatDialogRef<UserConfirmAccountDialogComponent>,
        public userService: UserService,
    ) {}

    ngOnInit(): void {
        this.userService.getProfileById(this.data.id).subscribe((profile) => (this.profile = profile));
    }

    sendConfirmAccountEmail(): void {
        this.dialogRef.close(true);
    }

    closeModal(): void {
        this.dialogRef.close(false);
    }
}
